import React, { Fragment, useState } from 'react'

import icons from './../../images/icons.svg'
import '../../i18n';
import { useTranslation } from 'react-i18next';

const WishOverlay = ({ open, toggleOverlay, submitWishes }) => {
    const { t } = useTranslation();

    const [wishesText, setWishesText] = useState()
    const [wishesSent, setWishesSent] = useState(false)

    const submit = () => {
        submitWishes(wishesText)
        setWishesSent(true)
    }
    return (
        <Fragment>
            <div className={`wish-overlay ${open ? 'wish-overlay--open' : ''}`}>
                <div className="wish-overlay__container wish-overlay__container--nextpage">

                    {wishesSent ? (
                        <div className="wish-overlay__thankyou">
                            <svg className="wish-overlay__thankyou-icon" id="exclamation-icon">
                                <use xlinkHref={`${icons}#icon-checkmark`}></use>
                            </svg>
                            <div className="wish-overlay__thankyou-text">
                                {t('responseThankYou')}
                            </div>
                        </div>
                    ) : (
                        <Fragment>
                            <div className="wish-overlay__header">
                                {t('leaveWishes')}
                            </div>

                            <div className="wish-overlay__cta">
                                <textarea className="wish-overlay__textbox" rows="6" onChange={(event) => { setWishesText(event.target.value) }}></textarea>
                                <div className={`wish-overlay__send ${!wishesText ? 'wish-overlay__send--disabled' : ''}`} onClick={() => { submit() }}>
                                    <span>{t('send')}</span>
                                </div>
                            </div>
                        </Fragment>
                    )
                    }
                    <div className="wish-overlay__send wish-overlay__send--notnow" onClick={() => {
                        toggleOverlay(false)
                        setWishesSent(false)
                        setWishesText()
                    }}>
                        <span>{t('close')}</span>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default WishOverlay